export default __webpack_public_path__ + "static/banner--cloud-small@2x-ea06514c32dc4f008b91bcafdd6cdd64.png";